import React from "react";
import Icon, { IconProps } from "./Icon";

/**
 * Real Estate icon for representing property and real estate services
 */
export const RealEstateIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
      <polyline points="9 22 9 12 15 12 15 22"></polyline>
    </Icon>
  );
};

export default RealEstateIcon;
